var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.user.hasRole(['manager', 'admin', 'staff', 'external_manager']))?_c('comments',{attrs:{"resource":'admin/projects/projects/' + _vm.item.id,"user":_vm.user,"isAuth":_vm.isAuth},on:{"reload":_vm.reload}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f71174","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/projects/views/Comments.vue
// module id = null
// module chunks = 